import React, {useEffect} from 'react';
import logo from '@assets/images/logo.png';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {translate} from '@src/helpers';
import '@pages/page-not-found/page-not-found.scss';

const PageNotFound = () => {
  const langData = useSelector((state: any) => state.currentLanguage) as any;
  useEffect(() => {
    const bodyEl = document.querySelector("body");
    if(bodyEl) {
      bodyEl.classList.add("body-tertiary");
    }

    return () => {
      if(bodyEl) {
        bodyEl.classList.remove("body-tertiary");
      }
    };
  }, []);
  return (
    <main>
      <div className="container h-100">
        <div className="row h-100 section-message">
          <div className="col-sm-12 mx-auto my-auto">
            <div className="text-center section-logo">
              <Link to="/"><img src={logo} alt="logo" /></Link>
            </div>
            <div className="page-error">{translate(langData.localize, "FIP.ERROR.PAGE_NOT_FOUND")}</div>
            <form>
              <div className="message-buttons mt-4">
                <Link to="/" className="btn-green btn-green--big btn-flex">{translate(langData.localize, "FIP.COMMON.HOME")}</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}

export default PageNotFound;
